export default "__VITE_ASSET__DzMW0dK4__"